import { useEffect, useState } from "react";

export const PENDING_DOTS_DELAY_MS = 1000;

/**
 * Delays reporting an in-flight action as "long" until it has been pending for
 * `delayMs`, so brief requests never show the pending-dots indicator. Returns
 * false again the moment the action settles. Independent of the slow-request
 * notice in WidgetRequestContext, which has its own longer delay.
 */
export function usePendingDelay(isPending: boolean, delayMs: number = PENDING_DOTS_DELAY_MS): boolean {
  const [delayed, setDelayed] = useState(false);

  useEffect(() => {
    if (!isPending) return;

    const timer = setTimeout(() => setDelayed(true), delayMs);
    return () => {
      clearTimeout(timer);
      setDelayed(false);
    };
  }, [isPending, delayMs]);

  return isPending && delayed;
}
